var _g, _path, _g2, _g3, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 30,
    r: 18,
    fill: "#053668"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 12C50.1046 12 51 12.8954 51 14L51 48C51 49.1046 50.1046 50 49 50L6 50C4.89543 50 4 49.1046 4 48L4 11C4 9.89543 4.89543 9 6 9L18.5858 9C18.851 9 19.1054 9.10536 19.2929 9.29289L21.7071 11.7071C21.8946 11.8946 22.149 12 22.4142 12L49 12Z",
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49 12C50.1046 12 51 12.8954 51 14L51 48C51 49.1046 50.1046 50 49 50L6 50C4.89543 50 4 49.1046 4 48L4 11C4 9.89543 4.89543 9 6 9L18.5858 9C18.851 9 19.1054 9.10536 19.2929 9.29289L21.7071 11.7071C21.8946 11.8946 22.149 12 22.4142 12L49 12Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7922 16.7663C8.9107 15.7591 9.76433 15 10.7785 15H52.7731C53.4065 15 53.8803 15.5813 53.7526 16.2017L47.1644 48.2017C47.0687 48.6665 46.6595 49 46.1849 49H6.12454C5.52595 49 5.06145 48.4777 5.13139 47.8832L8.7922 16.7663Z",
    fill: "#F3F5F4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6865 19.62C11.8685 18.6794 12.692 18 13.65 18H54.749C55.3902 18 55.8657 18.5949 55.7245 19.2203L49.1761 48.2203C49.0731 48.6762 48.668 49 48.2006 49H7.2121C6.58359 49 6.1109 48.427 6.23033 47.81L11.6865 19.62Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6865 19.62C11.8685 18.6794 12.692 18 13.65 18H54.749C55.3902 18 55.8657 18.5949 55.7245 19.2203L49.1761 48.2203C49.0731 48.6762 48.668 49 48.2006 49H7.2121C6.58359 49 6.1109 48.427 6.23033 47.81L11.6865 19.62Z",
    fill: "url(#bu-paint1_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7719 21C57.4057 21 57.8796 21.582 57.7512 22.2026L52.4949 47.6078C52.2067 49.0009 50.9797 50 49.5572 50L4 50L5.37144 50C6.31982 50 7.13781 49.3339 7.32995 48.4052L12.67 22.5948C12.8622 21.6661 13.6802 21 14.6286 21L56.7719 21Z",
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.7719 21C57.4057 21 57.8796 21.582 57.7512 22.2026L52.4949 47.6078C52.2067 49.0009 50.9797 50 49.5572 50L4 50L5.37144 50C6.31982 50 7.13781 49.3339 7.32995 48.4052L12.67 22.5948C12.8622 21.6661 13.6802 21 14.6286 21L56.7719 21Z",
    fill: "url(#bu-paint2_linear)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: -5,
    y: -12,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 3.625,
    y: 13.5,
    width: 50.6491,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 4.71094,
    y: 16.5,
    width: 51.5376,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu-paint0_linear",
    x1: 50,
    y1: 9,
    x2: 50,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu-paint1_linear",
    x1: 37.8864,
    y1: 8.62963,
    x2: 30.0857,
    y2: 44.7991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu-paint2_linear",
    x1: 3.99999,
    y1: 33.75,
    x2: 42.0322,
    y2: 18.5593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.f5d9d0e8.svg";
export { ForwardRef as ReactComponent };